import { render, staticRenderFns } from "./TheLayoutHeader.vue?vue&type=template&id=81788bd6&"
import script from "./TheLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./TheLayoutHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports